// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ButtonGroupController from "./button_group_controller"
application.register("button-group", ButtonGroupController)

import Charts__BarController from "./charts/bar_controller"
application.register("charts--bar", Charts__BarController)

import Charts__ForecastController from "./charts/forecast_controller"
application.register("charts--forecast", Charts__ForecastController)

import Charts__ForecastWeatherController from "./charts/forecast_weather_controller"
application.register("charts--forecast-weather", Charts__ForecastWeatherController)

import Charts__GaugeController from "./charts/gauge_controller"
application.register("charts--gauge", Charts__GaugeController)

import Charts__OperationsController from "./charts/operations_controller"
application.register("charts--operations", Charts__OperationsController)

import Charts__PowerCurvesController from "./charts/power_curves_controller"
application.register("charts--power-curves", Charts__PowerCurvesController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import DeviceSelectorController from "./device_selector_controller"
application.register("device-selector", DeviceSelectorController)

import DropdownFilterController from "./dropdown_filter_controller"
application.register("dropdown-filter", DropdownFilterController)

import DurationCalculatorController from "./duration_calculator_controller"
application.register("duration-calculator", DurationCalculatorController)

import ExportController from "./export_controller"
application.register("export", ExportController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import LightningStrikesMapController from "./lightning_strikes_map_controller"
application.register("lightning-strikes-map", LightningStrikesMapController)

import PowerCurveController from "./power_curve_controller"
application.register("power-curve", PowerCurveController)

import PowerCurveFormController from "./power_curve_form_controller"
application.register("power-curve-form", PowerCurveFormController)

import PowerCurveSparklineController from "./power_curve_sparkline_controller"
application.register("power-curve-sparkline", PowerCurveSparklineController)

import RemoteModalController from "./remote_modal_controller"
application.register("remote-modal", RemoteModalController)

import SelectController from "./select_controller"
application.register("select", SelectController)
